module.exports = __webpack_public_path__ + "static/media/newscript2.75e58ced.jpg";